module.exports = __webpack_public_path__ + "img/partners-icon3.6c1be923.jpg";